import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { Certification } from '@cpd-app/core-module/models';

export const certificationFeatureKey = 'certification';

export interface CertificationState extends EntityState<Certification> {
  error: any;
}

export const certificationStateAdapter: EntityAdapter<Certification> =
  createEntityAdapter<Certification>({
    selectId: (certification: Certification) => certification.certId,
    sortComparer: false
  });

export const initialCertificationState: CertificationState =
  certificationStateAdapter.getInitialState({
    error: null
  });

export const { selectIds, selectEntities, selectAll, selectTotal } =
  certificationStateAdapter.getSelectors();
